import { GetProviderProfileResponse } from '@uplift/api';
import { createContext, useContext } from 'react';

export type ProfileContextType = {
  profile: GetProviderProfileResponse['data'] & { avatarAssetOriginal: GetProviderProfileResponse['data']['avatarAsset'] };
  loading: boolean;
};

export const ProfileContext = createContext<ProfileContextType>({
  profile: null,
  loading: false,
});

export const useProfileContext = () => {
  const context = useContext(ProfileContext);

  if (!context) {
    throw new Error('useProfileContext must be used within a ProfileContextProvider');
  }

  return context;
};
